import Date from '@/modules/AdminTools/components/Form/Date';

const StartDate = () => (
  <Date name="plan_data.start_on" label="Start On" required />
);

export default StartDate;
